import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetGameDetails } from "../../GameServices/GameServices";

const ChallengesCard = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const [GameData, setGameData] = useState([]);
  useEffect(() => {
    FetchGames();
  }, []);
  const FetchGames = async () => {
    let { data } = await GetGameDetails(params.id);
    setGameData(data);
  };

  const handleGamePlay = () => {
    if (!props.isAuthenticated) {
      props.handlePopup(true);
    } else {
      let game = props.gameInfo;
      localStorage.setItem("gameId", game.gameId);
      navigate(`/match`, {
        state: {
          id: 1,
          type: game.stage,
          value: game.betAmount,
          name: game.gameName,
          gameBuild: GameData?.gameBuild,
          gameClass: GameData?.gameClass,
          gameType: "OneVSOne",
          direct: true,
          code: "",
        },
      });
    }
  };
  return (
    <div
      className={`col-lg-${props.col} challenging ${
        props.className ? props.className : ""
      }`}
    >
      <span className="bar"></span>
      <div className="sore-main w-100">
        <div className="score1">
          <h2>Join Bet</h2>
          <div className="challenge div">
            <h3>{props?.gameInfo?.betAmount}</h3>
            <img src={require("./../../Assets/img/matic.png")} alt="matic" />
          </div>
        </div>
        <div className="score2">
          <div className="challenge div">
            <div className="star">
              {" "}
              <h3 className="startBg">
                <span>
                  Score <br />
                </span>
                to beat
              </h3>
            </div>
            <h2>{props?.gameInfo?.player1?.score}</h2>
            <h5>POINTS</h5>
          </div>
        </div>
      </div>

      <a
        onClick={() => {
          handleGamePlay();
        }}
      >
        {" "}
        Play Now
      </a>
    </div>
  );
};

export default React.memo(ChallengesCard);
